










































import { Component, Vue, Watch, Prop } from 'nuxt-property-decorator'
import ARangeSlider from '../App/AppRangeSlider.vue'

import { Service } from './BriefViewServices.vue'

@Component<MBriefBudget>({})
export default class MBriefBudget extends Vue {
  dontKnow = false

  @Prop({ default: 'web', required: true }) budgetType!: Service

  budgetRangesList = {
    'web': [10000, 400000],
    'mobile': [20000, 600000],
    'product-design': [5000, 200000],
    'qa-and-testing': [5000, 200000],
    'outsourcing': [10000, 400000],
    'branding': [5000, 200000],
    'ui-ux-design': [5000, 200000],
    'seo-sem-sxo': [5000, 200000],
    'marketing': [5000, 200000],
    'social-media': [5000, 200000]
  }

  get budgetRangeMinMax() {
    return [this.budgetRangesList[this.budgetType][0], this.budgetRangesList[this.budgetType][1]]
  }

  budgetRange = [this.budgetRangesList[this.budgetType][0], this.budgetRangesList[this.budgetType][1]]

  get sliderOptions(): noUiSlider.Options {
    return {
      range: {
        min: this.budgetRangeMinMax[0],
        max: this.budgetRangeMinMax[1]
      },
      start: this.budgetRangeMinMax,
      connect: true,
      step: 1000,
      margin: 1000,
      animate: true
    }
  }

  @Watch('budgetType', { deep: true, immediate: true })
  onBudgetTypeChange(type: Service, oldType: any) {
    setTimeout(() => {
      this.updateBudget(0, this.budgetRangesList[type][0])
      this.updateBudget(1, this.budgetRangesList[type][1])
    }, 100)
  }

  updateBudget(index: number, value: number) {
    this.budgetRange[index] = value
    const range = this.$refs.range as ARangeSlider
    if (range && range.slider) {
      range.slider.set(this.budgetRange)
    }

    this.emitValue()
  }

  @Watch('budgetRange', { deep: true, immediate: true })
  emitValue() {
    this.$emit('input', this.dontKnow ? undefined : { min: this.budgetRange[0], max: this.budgetRange[1] })
  }

  get serviceName() {
    switch (this.budgetType) {
      case 'web': return this.$tc('services.web.name')
      case 'mobile': return this.$tc('services.mobile.name')
      case 'product-design': return this.$tc('services.product-design.name')
      case 'qa-and-testing': return this.$tc('services.qa-and-testing.name')
      case 'outsourcing': return this.$tc('services.outsourcing.name')
      case 'branding': return this.$tc('services.branding.name')
      case 'ui-ux-design': return this.$tc('services.ui-ux-design.name')
      case 'seo-sem-sxo': return this.$tc('services.seo-sem-sxo.name')
      case 'marketing': return this.$tc('services.marketing.name')
      case 'social-media': return this.$tc('services.social-media.name')
      default: return this.budgetType
    }
  }
}
